<template>
    <div>
        <h2 class="summary-heading">
            {{title}}
        </h2><br/>
        <form @submit.prevent class="m-form" name="claimInfoForm">
            <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
                <div class="flex-grid__item">
                    <control name="claim_status" label="Status:">
                        <select name="claimStatus"
                                id="claim_status"
                                v-field-control
                                v-model="active"
                                required>
                            <option :value="true">Open</option>
                            <option :value="false">Closed</option>
                        </select>
                    </control>
                    <control for="open_date" label="Open Date:">
                        <date-input v-model="openDate"
                                    v-field-control:open_date.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('open_date')">
                            The Open Date is required
                        </control-error>
                    </control>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                    <control for="closed_date" label="Closed Date:" v-if="!active">
                        <date-input v-model="closeDate"
                                    v-field-control:closed_date.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('closed_date')">
                            The Closed Date is required
                        </control-error>
                        <control-error :show="closedDateRules">
                            The Closed Date must be after the Open Date
                        </control-error>
                    </control>
                    <control for="claim_outcome" label="Outcome:" v-if="!active">
                        <select name="claimOutcome"
                                id="claim_outcome"
                                v-field-control
                                v-model="outcome"
                                required>
                            <option value=null disabled hidden>Please select...</option>
                            <option value="Paid">Paid</option>
                            <option value="Defended">Defended</option>
                        </select>
                        <control-error :show="$error('claim_outcome')">
                            The Outcome is required
                        </control-error>
                    </control>
                    <div class="flex-grid flex-grid--reduced-bottom-margin">
                        <div class="flex-grid__g-2 flex-grid--input-label">
                        </div>
                        <div class="flex-grid__g-7">
                            <button @click="save()" class="a-button a-button--no-margin">Save</button>
                            <button v-if="showBack" @click="close('showAllSummary')" class="a-button a-button--no-margin">Back</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import _ from 'lodash';
    import Vue from 'vue';
    import DateInput from 'components/form/control/DateInput.vue';
    import Control from 'components/form/Control.vue';
    import moment from 'moment';
    import ControlError from '../../../components/form/control/Error.vue';
    import FormValidator from '../../../components/form/validator/mixin';

    export default {
        name: 'claim-info',
        props: {
            claim: {
                type: Object,
                required: true
            },
            showBack: {
                type: Boolean,
                default: true
            },
            title: {
                type: String,
                default: "Claim Info (editing)"
            }
        },
        data() {
            return {
                active: !!this.claim.active,
                openDate: this.claim.open_date ? moment(this.claim.open_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
                    : moment(this.claim.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
                closeDate: this.claim.close_date ? moment(this.claim.close_date, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
                    : moment().format('DD/MM/YYYY'),
                outcome: this.claim.outcome
            };
        },
        components: {
            Control,
            DateInput,
            ControlError
        },
        mixins: [
            FormValidator
        ],
        computed: {
            closedDateRules() {
                if (moment(this.closeDate, 'DD/MM/YYYY')
                        .isBefore(moment(this.openDate, 'DD/MM/YYYY'))) {
                    return true;
                }
                return false;
            }
        },
        methods: {
            close(value) {
                this.$emit('close', value);
            },
            save() {
                this.$emit('save', {
                    claim_id: this.claim.id,
                    open_date: this.openDate,
                    active: this.active,
                    outcome: this.active ? null : this.outcome,
                    close_date: this.active ? null : this.closeDate,
                });
            }
        },
    }
</script>


// WEBPACK FOOTER //
// ClaimInfo.vue?0c6c497b